/**
 * Turkiz Press — Info Cards Component
 *
 * Interactive behaviors for info card components.
 *
 * @package TurkizPress
 * @since   2.0.0
 */

/**
 * Initialize info cards.
 */
export function init() {
    setupDismissable();
}

/**
 * Make info cards dismissable (optional).
 */
function setupDismissable() {
    const cards = document.querySelectorAll( '.turkiz-info-card[data-dismissable]' );

    cards.forEach( ( card ) => {
        const closeBtn = card.querySelector( '.turkiz-info-card__close' );
        if ( ! closeBtn ) return;

        closeBtn.addEventListener( 'click', () => {
            card.style.opacity = '0';
            card.style.transform = 'translateY(-10px)';

            setTimeout( () => {
                card.remove();
            }, 250 );
        } );
    } );
}
